import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Form, Formik } from 'formik';
import { Row, Col } from 'reactstrap';
import UserListInfoSection from './UserListInfoSection';
import ButtonSection from '../../../organization/create-organization/ButtonSection';
import { UserListTableData } from '../../../../data/users/UsersList';
import { UserListTableDataColumnType } from '../../../../types/users/UserTypes';

const EditUserList = () => {
  const navigate = useNavigate();
  const { id } = useParams();
 
  const UserListData = id ? UserListTableData.find(item => item.id?.toString() === id) as UserListTableDataColumnType | undefined : null;
   console.log(UserListData,"User list data edit ")

  const initialValues = UserListData || {
    firstName: "",
    lastName: "",
    mobileNumber: "",
    email: "",
    countrycode: "",
    gender: "",
    birthDate: null,
    organizationname: "",
    userImage: "",
    languages:[]
  };
  const handleClose=()=>{
    navigate('/users/organizationadmin')
  }

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={(values) => {
        console.log(values);
      }}
      enableReinitialize
    >
      {() => (
        <Form className="theme-form">
          <Row>
            <Col>
              <UserListInfoSection data={UserListData} />
              <ButtonSection onClose={handleClose}/>
          
            </Col>
          </Row>
        </Form>
      )}
    </Formik>
  );
};

export default EditUserList;

